import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const PAYMENT_IFRAME_ID = 'payment-modal-iframe-script-toolbar-plus-1755832065'; // manter este nome por questões de compatibilidade com o script legado até que seja totalmente desativado
const TRANSITION_MS = 300;

interface PaymentModalProps {
	link: string;
}

const PaymentModal = ({ link }: PaymentModalProps) => {
	// Evita duplicação caso o script JS legado tenha aberto o modal antes
	// do React montar. Se o iframe com este ID já existir no DOM, não renderiza.
	const [shouldRender, setShouldRender] = useState(() => typeof document === 'undefined' || !document.getElementById(PAYMENT_IFRAME_ID));
	const [isOpen, setIsOpen] = useState(true);
	const [isVisible, setIsVisible] = useState(false);

	// Dispara o fade-in logo após a montagem (equivalente à classe `.generic-modal-show`)
	useEffect(() => {
		const raf = requestAnimationFrame(() => setIsVisible(true));
		return () => cancelAnimationFrame(raf);
	}, []);

	useEffect(() => {
		const handleMessage = (event: MessageEvent) => {
			try {
				if (event.data && event.data.action === 'closePaymentModal') {
					console.log('recebendo postmessage para fechar modal de pagamento');
					setIsVisible(false);
					// aguarda o fade-out terminar antes de desmontar o iframe
					window.setTimeout(() => {
						setIsOpen(false);
						setShouldRender(false);
					}, TRANSITION_MS);
				}
			} catch (err) {
				console.log('erro ao processar postmessage', (err as Error).message);
			}
		};

		window.addEventListener('message', handleMessage);
		return () => window.removeEventListener('message', handleMessage);
	}, []);

	if (!shouldRender || !isOpen || !link) return null;

	return createPortal(
		<div
			className={`fixed top-0 left-0 w-full h-screen flex items-center justify-center bg-black/80 z-[99999] transition-[opacity,visibility] duration-300 ease-in-out ${
				isVisible ? 'opacity-100 visible' : 'opacity-0 invisible'
			}`}
			role='dialog'
			aria-modal='true'>
			<div className='w-full h-screen flex items-center justify-center'>
				<iframe
					id={PAYMENT_IFRAME_ID}
					src={link}
					allow='payment; encrypted-media'
					className='!w-full !h-full !border-0 !rounded-none !shadow-none'
				/>
			</div>
		</div>,
		document.body
	);
};

export default PaymentModal;
